import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { Observable, finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { IEditModulLocatieActivaPayload, IModulLocatieActivaDT, IModulLocatieActivaForm } from '../module-locatii-active.interface';
import { ModuleLocatiiActiveService } from '../module-locatii-active.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { formatDate } from '@angular/common';
import { ModuleService } from '../../module/module.service';
import { dateRangeValidator } from 'src/app/validators/date-range';

@Component({
    selector: 'app-edit-module-locatii-active',
    templateUrl: './edit-module-locatii-active.component.html',
    styleUrls: ['./edit-module-locatii-active.component.scss']
})
export class EditModuleLocatiiActiveComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    helper = helper;
    isLoading = false;
    formattedDate!: string;
    today = new Date();

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    modules$!: Observable<Generic[]>;
    locatii$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        id_modul: new FormControl(this.data.id_modul, [Validators.required, Validators.min(0)]),
        id_locatie: new FormControl(this.data.id_locatie, [Validators.required, Validators.min(0)]),
        min_date_available: new FormControl(this.data.min_date_available, [Validators.required]),
        max_date_available: new FormControl(this.data.max_date_available, [Validators.required]),
    }, { validators: [dateRangeValidator('min_date_available', 'max_date_available')] });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IModulLocatieActivaDT,
        private dialogRef: MatDialogRef<EditModuleLocatiiActiveComponent>,
        private moduleLocatiiActiveService: ModuleLocatiiActiveService,
        private notificationService: NotificationService,
        private locatiiService: LocatiiService,
        private moduleService: ModuleService,
    ) { }

    ngOnInit(): void {
        this.loadModules();
        this.loadLocatii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onDateChange(event: any) {
        this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
    }

    loadModules() {
        this.isLoading = true;
        this.modules$ = this.moduleService.listModule().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatii$ = this.locatiiService.listLocatii().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { id_locatie, id_modul, min_date_available, max_date_available } = this.form.value as IModulLocatieActivaForm;
        const payload: IEditModulLocatieActivaPayload = {
            id: this.data.id,
            id_locatie,
            id_modul,
            min_date_available: formatDate(min_date_available, 'yyyy-MM-dd', 'en-US'),
            max_date_available: formatDate(max_date_available, 'yyyy-MM-dd', 'en-US'),
        };

        this.moduleLocatiiActiveService
            .updateModulLocatieActiva(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
